import styled from 'styled-components';
import { AccordionDetails as MuiAccordionDetails } from '@mui/material';
import { radius, space } from '../../style/utils';

const AccordionDetails = styled(MuiAccordionDetails)`
  background-color: ${({ theme }) => theme.palette.surface.muted};
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  border-radius: ${radius(0, 0, 'lg', 'lg')};
  padding: ${space('xxl')};
`;

export default AccordionDetails;
